/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Notifications } from './Notifications';
import { NotificationsFromJSON, NotificationsFromJSONTyped, NotificationsToJSON } from './Notifications';

/**
 *
 * @export
 * @interface PaginatedNotificationsList
 */
export interface PaginatedNotificationsList {
  /**
   *
   * @type {number}
   * @memberof PaginatedNotificationsList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedNotificationsList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedNotificationsList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Notifications>}
   * @memberof PaginatedNotificationsList
   */
  results: Array<Notifications>;
}

/**
 * Check if a given object implements the PaginatedNotificationsList interface.
 */
export function instanceOfPaginatedNotificationsList(value: object): value is PaginatedNotificationsList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedNotificationsListFromJSON(json: any): PaginatedNotificationsList {
  return PaginatedNotificationsListFromJSONTyped(json, false);
}

export function PaginatedNotificationsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedNotificationsList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(NotificationsFromJSON),
  };
}

export function PaginatedNotificationsListToJSON(value?: PaginatedNotificationsList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(NotificationsToJSON),
  };
}
